import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { graphqlRequest} from '../../services/graphql-service.js';
import { GET_TRACK_WITH_THREADS } from '../../config/queries.js';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Tabs, Tab } from '@mui/material';
import { timeout, playDelay } from '../../utils/utils';
import { selectTrack } from '../../features/audioPlayer/audioPlayerSlice';
import { usePub } from '../../hooks/usePubSub';
import { useTheme } from '@mui/material/styles';
import './track.css';
// import Conversation from '../conversation/conversation';
import PlayButton from '../../assets/images/track_controls/play_ico_round.png';
import PauseButton from '../../assets/images/track_controls/pause_ico_round.png';
import StemList from '../stem-list/stem-list';
import ArtistDetailsBlock from '../artist-details-block/artist-details-block';
import Footer from '../footer/footer';
// import {artist_stream_data} from '../../config/artist-temp-stream-data';
// import ArtistStreamDetails from '../artist-stream-details/artist-stream-details';
// import socialYoutube from '../../assets/images/social/white/youtube.png';
// import socialSpotify from '../../assets/images/social/white/spotify.png';
// import socialTiktok from '../../assets/images/social/white/tiktok.png';


const TabPanel = ({ children, value, index }) => {
    
    return (
      <div role="tabpanel" hidden={value !== index}>
        {value === index && (
          <Box sx={{ p: 3 }}>
            {children}
          </Box>
        )}
      </div>
    );
};

const Track = () => {
    const dispatch = useDispatch();
	const publish = usePub();
    const theme = useTheme();

	const trackIsPlaying = useSelector(state => state.audioPlayer.trackIsPlaying);
	const currentTrack = useSelector(state => state.audioPlayer.currentTrack);
    const [tabValue, setTabValue] = useState(0);
    const { id } = useParams();
    const [trackData, setTrackData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    
    useEffect(() => {
        const fetchTrackData = async () => {
            try {
                setLoading(true);
                const data = await graphqlRequest(GET_TRACK_WITH_THREADS, { trackId: id });
                setTrackData(data.track);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };
        fetchTrackData();
    }, [id]);

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    // TODO: move this into utils
    const handlePlayPauseClick = async (event, track) => {
        event.stopPropagation();
		let changedSelection = false;
		// select the track if it is not the current track
		if (!currentTrack || (currentTrack && currentTrack.id !== track.id)) {
			changedSelection = true;
			dispatch(selectTrack(track));
		}
		// handle play/pause
		if (changedSelection) {
			await timeout(playDelay); // allow next audio source to load
            publish('audioPlayerEvent',{action:'play', track: track})
		} else {
			if (!trackIsPlaying) {
				publish('audioPlayerEvent',{action:'play', track: track})
			} else {
				publish('audioPlayerEvent',{action:'pause', track: track})
			}
		}
    };

    const IsThisTrackPlaying = () => {
        if (currentTrack && currentTrack.id === trackData.id && trackIsPlaying) {
            return true
        } else {
            return false;
        }
    }

    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error}</p>;
    
    return (
      <div className="track-page-container">
        <div className='track-summary-block'>
           
            <div className="track-blurred-bg">
                <div className="track-blur-layer"
                    style={{
                        background: `url(https://media.tracktribe.com/images/track_images/${trackData.image}) no-repeat center center/cover`
                    }}
                />
                    <div className='track-summary-block-content'>
                        <div className='track-label'>Track</div>
                        <div className='track-hero-image' 
                            style={{ backgroundImage: `url(https://media.tracktribe.com/images/track_images/${trackData.image})`}} 
                        >
                            <img 
                                className='track-page-play-button' 
                                src={ IsThisTrackPlaying() ? PauseButton : PlayButton } 
                                alt='' 
                                onClick={(event) => handlePlayPauseClick(event, trackData)}
                            />
                        </div>
                       
                        <div className='track-details-block'>
                            <div className='track-title'>{trackData.title}</div>
                            
                            <ArtistDetailsBlock artist={trackData.artist} />

                            {/* {trackData.featured_artist && (
                                <div>
                                    <div className='track-detail-item'><b>Featured Artist: </b></div>
                                    <ArtistDetailsBlock artist={trackData.featured_artist} />
                                </div>
                            )} */}

                            {/* <div className='artist-stream-details-group'>
                                <ArtistStreamDetails 
                                    first={true}
                                    label='TOTAL STREAMS' 
                                    value={artist_stream_data.total.streams}
                                    performance={artist_stream_data.total.performance}
                                />
                                <ArtistStreamDetails 
                                    label='SPOTIFY' 
                                    value={artist_stream_data.spotify.streams}
                                    performance={artist_stream_data.spotify.performance}
                                    logo={socialSpotify}
                                />
                                <ArtistStreamDetails 
                                    label='TIKTOK' 
                                    value={artist_stream_data.tiktok.streams}
                                    performance={artist_stream_data.tiktok.performance}
                                    logo={socialTiktok}
                                />
                                <ArtistStreamDetails 
                                    label='YOUTUBE' 
                                    value={artist_stream_data.youtube.streams}
                                    performance={artist_stream_data.youtube.performance}
                                    logo={socialYoutube}
                                />
                            </div> */}
                        </div>
                    </div>
            </div>


        </div>

        <Box sx={{ width: '100%' }}>
            {/* Tab Navigation */}
            <Tabs value={tabValue} onChange={handleTabChange} centered>
                <Tab 
                    label="Stems" 
                    sx= {{
                        color: theme.palette.color
                    }}
                />
                <Tab 
                    label="Blox" 
                    sx= {{
                        color: theme.palette.color
                    }}
                />
                <Tab 
                    label="Comments" 
                    sx= {{
                        color: theme.palette.color
                    }}
                />
            </Tabs>

            {/* Tab Content */}
            <TabPanel value={tabValue} index={0}>
                <StemList trackList={trackData.stems} parentTrackTitle={trackData.title}/>
            </TabPanel>
            <TabPanel value={tabValue} index={1}>
                <h3>Coming soon...</h3>
            </TabPanel>
            <TabPanel value={tabValue} index={2}>
                <h3>Coming soon...</h3>
                {/* {trackData.track_conversations.map((convo) => {
                    return <Conversation conversation={convo} key={convo.id}/>
                })} */}
            </TabPanel>
        </Box>
        <Footer />
      </div>
    );
};

export default Track;